export default __webpack_public_path__ + "lines_mobile.a20092b6.png";